// @ts-nocheck
import { isFileTypeAndExtensionAllowed } from './fileValidation';

/**
 * Supported image formats configuration
 * Centralized list of supported image MIME types and file extensions
 */

/**
 * List of supported image MIME types
 * @type {string[]}
 */
export const SUPPORTED_IMAGE_MIME_TYPES = [
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp'
];

/**
 * List of supported image file extensions (for HTML input accept attribute)
 * @type {string}
 */
export const SUPPORTED_IMAGE_FILE_EXTENSIONS = [
  '.gif',
  '.jpg',
  '.jpeg',
  '.png',
  '.webp'
];

export const SUPPORTED_IMAGE_EXTENSIONS =
  SUPPORTED_IMAGE_FILE_EXTENSIONS.join(',');

/**
 * Check if a given MIME type is supported
 * @param {string} mimeType - The MIME type to check
 * @returns {boolean} - True if the MIME type is supported
 */
export const isSupportedImageFormat = (mimeType) => {
  return SUPPORTED_IMAGE_MIME_TYPES.includes(mimeType?.toLowerCase());
};

/**
 * Check if a file is a supported image format
 * @param {File} file - The file object to check
 * @returns {boolean} - True if the file is a supported image format
 */
export const isSupportedImageFile = (file) => {
  return isFileTypeAndExtensionAllowed(
    file,
    SUPPORTED_IMAGE_MIME_TYPES,
    SUPPORTED_IMAGE_FILE_EXTENSIONS
  );
};

/**
 * Get a formatted string of supported formats for user messages
 * @returns {string} - Comma-separated list of supported formats
 */
export const getSupportedFormatsString = () => {
  return 'GIF, JPG, JPEG, PNG, and WebP';
};
